export default __webpack_public_path__ + "9cdf07e3abc517a7859dddb7e785f927.svg";